import { handleResponse, restartUserSession, authHeader } from '../helpers'

export const subscriptionService = {
    getPlans,
    createPlan,
    deletePlan,
    createSubscriptionUrl,
    sendSubscriptionUrl,
    getSubscriptionUrls,
    getPlansSubscriptions,
    savePlansSubscriptions,
    updateSubscriptionSettings,
    createDonationSession,
    stopGiftSubscription,
    sendSupportMessage,
    createPaypalSession,
    capturePaypalOrder,
    getGhostProducts,
    loadGhostProductsWithOther,
    getGhostPlan,
    createGhostPlan,
    updateGhostPlan,
    createUrlSubscriptionSession
}

function getPlans () {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    return fetch(`/subscription/plans`, requestOptions).then(handleResponse)
}

function createPlan (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/create-plan`, requestOptions).then(handleResponse)
}

function deletePlan (id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    }

    return fetch(`/subscription/delete-plan/${id}`, requestOptions).then(handleResponse)
}

function createSubscriptionUrl (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/create-subscription-url`, requestOptions).then(handleResponse)
}

function sendSubscriptionUrl (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/send-subscription-url`, requestOptions).then(handleResponse)
}

function getSubscriptionUrls (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/get-subscription-urls`, requestOptions).then(handleResponse)
}

function updateSubscriptionSettings (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/public/unsubscribe`, requestOptions).then(handleResponse)
}

function getPlansSubscriptions (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/get-plans-subscriptions`, requestOptions).then(handleResponse)
}

function savePlansSubscriptions (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/save-plans-subscriptions`, requestOptions).then(handleResponse)
}

function createDonationSession (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/public/create-donation-session`, requestOptions).then(handleResponse)
}

function stopGiftSubscription (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/public/stop-gift-subscription`, requestOptions).then(handleResponse)
}

function sendSupportMessage (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/public/donation-send-support-message`, requestOptions).then(handleResponse)
}

function createPaypalSession (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/public/create-paypal-session`, requestOptions).then(handleResponse)
}

function capturePaypalOrder (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/public/capture-paypal-order`, requestOptions).then(handleResponse)
}

function getGhostProducts () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/subscription/ghost-products`, requestOptions).then(handleResponse)
}
function loadGhostProductsWithOther () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/subscription/ghost-products-with-other`, requestOptions).then(handleResponse)
}

function createGhostPlan (plan) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(plan)
    }

    return fetch(`/subscription/create-ghost-plan`, requestOptions).then(handleResponse)
}

function getGhostPlan (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }

    return fetch(`/subscription/get-ghost-plan/${id}`, requestOptions).then(handleResponse)
}

function updateGhostPlan (plan) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(plan)
    }

    return fetch(`/subscription/update-ghost-plan/${plan.id}`, requestOptions).then(handleResponse)
}

function createUrlSubscriptionSession (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/subscription/create-url-subscription-session`, requestOptions).then(handleResponse)
}
